<template>
	<details class="details">
    <summary class="button button-primary--small" v-if="label && label != ''">
      <span>{{ label }}</span>
    </summary>
    <div class="details--content"><slot></slot></div>
  </details>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
  },
  data: function() {
    return {
      active: false,
    };
  },
  methods: {
    clickHandler() {
      this.active = !this.active;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/Details.vue